export default function getResource(label, vars = []) {
    const resources = {
        addAllToBasket: 'Add All to Basket',
        addAllToBasketAria: `Add All to Basket, ${vars[0]} ${vars[0] === 1 ? 'item' : 'items'}`,
        addAllToBasketLoading: 'Adding items to your basket',
        atbErrorTitle: 'Error',
        atbErrorMessage: 'Something went wrong on our end. None of these items were added to your basket. Please try again.',
        atbErrorOk: 'OK',
        change: 'Change',
        currentProduct: 'Current Product',
        estimatedPrice: 'Total price:',
        frequentlyBoughtTogether: 'Frequently Bought Together',
        bundleProductOptions: 'Bundle product options',
        chooseBundleOptions: 'Choose Bundle Options',
        viewDetails: 'View Details',
        chooseSelection: 'Choose Selection',
        noOptionsAvailable: 'This item has no options available to edit.'
    };
    return resources[label];
}
